export default "__VITE_ASSET__c8710db5__"